import React from 'react'
import './subtask-2023.css'
import { freshSubSubtask, freshTask } from '../../AdminTasks/adminTaskUtils'
import SubSubtask2023 from './SubSubtask2023/SubSubtask2023'
import { CheckBadgeIcon } from '@heroicons/react/20/solid'
import { CheckIcon } from '@heroicons/react/24/outline'
import {getRequestHeaders} from '../../api'
import WarningPopup from '../../DanitComponents/Modals/WarningPopup/WarningPopup'
import axios from 'axios'
import { baseUrl } from '../../assets/Animations'
import { addDays, format, isAfter } from 'date-fns'

const Subtask2023 = ({subtask, openModal2023, setOpenModal2023, imEditingATemplate}) => {
    const [hoveringOverCheckbox, setHoveringOverCheckbox] = React.useState(false)
    const [warningPopup, setWarningPopup] = React.useState(false)
    const changeSubtaskName = (val) => {
        setOpenModal2023(prev => ({...prev, todoSubtasks: prev.todoSubtasks.map((sub) => sub.subtaskId === subtask.subtaskId ? {...sub, subtaskName: val} : sub)}))
    }

    const toggleCheckmark = () => {
        imEditingATemplate ? setOpenModal2023(prev => ({...prev, todoSubtasks: prev.todoSubtasks.filter((sub) => sub.subtaskId !== subtask.subtaskId && sub )}))
        : setOpenModal2023(prev => ({...prev, todoSubtasks: prev.todoSubtasks.map((sub) => sub.subtaskId === subtask.subtaskId ? {...sub, subtaskCompleted: !sub.subtaskCompleted} : sub )}))
        createTaskFromSpecialCheckbox(subtask)
    }

    const addSubSubtask = () => {
        setOpenModal2023(prev => ({...prev, todoSubtasks: prev.todoSubtasks.map((sub) => sub.subtaskId === subtask.subtaskId ? {...sub, subtaskSubtasks: [...sub.subtaskSubtasks, freshSubSubtask()]} : sub )}))
    }

    const checkForAutoClear = (val) => {
        val === "New Subtask" && setOpenModal2023((prev) => ({...prev, todoSubtasks: prev.todoSubtasks.map((sub) => sub.subtaskId === subtask.subtaskId ? {...sub, subtaskName: ''} : sub)}))
    }

    const specialTaskStyle = (name) => name.split(' ')[0] === 'Switch' ? 'orange' : '#64748B'

    const lookForIntroLesson = async () => {
        return axios.get(`${baseUrl}/calendar/family/${openModal2023.familyId}`, getRequestHeaders())
        .then((res) => {
            for(let i = 0; i < res.data.length; i++) {
                //check if its an intro lesson and in the future

                if(res.data[i].isIntro && isAfter(new Date(res.data[i].dateTime), new Date()) ) {
                    return res.data[i]
                }
            }
            return false
        })
        .catch((err) => console.log(err))
    }

    const createAReminderTask = (introLessonEvent) => {
        let myTask = {
            todoId: Math.random().toString(16).slice(2),
            todoName: `Intro Lesson Reminder - (${introLessonEvent.familyName})`,
            todoDescription: "Notes...",
            todoDueDate: addDays(new Date(introLessonEvent.dateTime), -1),
            todoAlarm: false,
            todoOwner: 'Bri',
            whichList: 'todos',
            whichSchool: 'all',
            todoSubtasks: []
        }
        axios.post(`${baseUrl}/tasks`, myTask, getRequestHeaders())
        .then((res) => setWarningPopup(false))
        .catch((err) => {
            console.log(err)
            alert('Failure to make task')
            setWarningPopup(false)
        })
    }


    const createTaskFromSpecialCheckbox = async (subtask) => {
        if(subtask.subtaskName.split(' ')[0] === 'Switch' && !subtask.subtaskCompleted) {
            let introLessonEvent = await lookForIntroLesson()
            if (introLessonEvent) {
                setWarningPopup({
                    type: 'confirm',
                    title: `Would you like to create a reminder task?`,
                    message: `There is an intro lesson scheduled for ${introLessonEvent.time} on ${format(new Date(introLessonEvent.dateTime), 'MMM do')}. Would you like a reminder task created for ${format(addDays(new Date(introLessonEvent.dateTime), -1), 'MMM do')}?`,
                    onConfirm: {
                        text: 'Create Task',
                        action: () => createAReminderTask(introLessonEvent)
                    },
                    onCancel: {
                        text: 'No thanks',
                        action: () => setWarningPopup(false)
                    }
                })
            } else {
                setWarningPopup({
                    type: 'confirm',
                    title: `No Intro Lesson Found`,
                    message: `Sorry, no intro lesson was found in the calendar.`,
                    onConfirm: {
                        text: 'Ok',
                        action: () => setWarningPopup(false)
                    },
                    onCancel: {
                        text: 'Close',
                        action: () => setWarningPopup(false)
                    }
                })
            }
        }
    }

    return(
        <div>
            {warningPopup && <WarningPopup warningPopup={warningPopup} setWarningPopup={setWarningPopup} />}
            <div className='subtask-2023__wrapper' style={ {opacity: subtask.subtaskCompleted ? 0.95 : 1}}>
                <div className='subtask-2023__main-check__wrapper'>
                    <div className='subtask-2023__check-box' onMouseEnter={() => setHoveringOverCheckbox(true)} onMouseLeave={() => setHoveringOverCheckbox(false)} onClick={toggleCheckmark} style={(subtask.subtaskCompleted || hoveringOverCheckbox) ? {backgroundColor: '#CCFBF1', border: '1px solid #14B8A6'} : {backgroundColor: '#fff'} }>
                        {(subtask.subtaskCompleted || hoveringOverCheckbox) && <CheckIcon className='subtask-2023__checkmark' color='#14B8A6' />}
                    </div>
                    <input className='subtask-2023__subtask-name' style={{color: specialTaskStyle(subtask.subtaskName)}} value={subtask.subtaskName} onClick={(e) => checkForAutoClear(e.target.value)} onChange={(e) => changeSubtaskName(e.target.value)} />
                    <div className='subtask-2023__add-sub-subtask' onClick={addSubSubtask}>+</div>
                </div>
                {subtask.subtaskSubtasks.map((sub2x) => <SubSubtask2023 key={sub2x.subtask2xId} sub2x={sub2x} subtask={subtask} setOpenModal2023={setOpenModal2023} imEditingATemplate={imEditingATemplate} />)}
            </div>
        </div>
    )
}
export default Subtask2023